export const BRAND = {
  logoUrl:
    'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/74lrfvzn_ChatGPT%20Image%20Jun%2025%2C%202026%20at%2007_22_45%20PM.png',
};

export const NAV_LINKS = [
  { id: 'about', label: 'About', href: '#about' },
  { id: 'team', label: 'Team', href: '#team' },
  { id: 'services', label: 'Services', href: '#services' },
  { id: 'industries', label: 'Industries', href: '#industries' },
  { id: 'thought-leadership', label: 'Thought Leadership', href: '#thought-leadership' },
  { id: 'contact', label: 'Contact', href: '#contact' },
];

export const HERO = {
  eyebrow: 'GLOBAL ADVISORY · HR · PEOPLE · CULTURE',
  headline: [
    'World-Class Organizations',
    'Are Built by Exceptional People',
    'and Great Culture.',
  ],
  subheadline:
    'We are a global People and Culture excellence advisory firm helping organisations achieve world-class business success by building high-performing teams, strengthening culture and unlocking sustainable growth.',
  primaryCta: { label: 'Contact Us', href: '#contact-form' },
  secondaryCta: { label: 'Explore Services', href: '#services' },
  videoUrl:
    'https://assets.mixkit.co/videos/preview/mixkit-modern-office-space-with-a-group-of-people-working-41598-large.mp4',
  fallbackImage:
    'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/6b0i0j8c_Screenshot%202026-07-25%20at%2012.31.09%E2%80%AFPM.png',
  heroImage:
    'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/6b0i0j8c_Screenshot%202026-07-25%20at%2012.31.09%E2%80%AFPM.png',
  heroImageAlt:
    'A melting pot of global talent — diverse hands pouring ingredients into a shared vessel, symbolising cross-cultural culture and collective ambition.',
};

export const ABOUT_CHAPTERS = [
  {
    n: '01',
    title: 'A Global Advisory',
    body: 'George & Milton is a global HR, People Practices, and Culture advisory where we help ambitious organizations find exceptional leaders, build winning cultures, and create workplaces where people choose to stay.',
  },
  {
    n: '02',
    title: 'Built for a VUCAH World',
    body: 'Today’s organizations operate in a VUCAH world defined by rapid technological change, economic uncertainty, and evolving workforce expectations. We help leaders navigate this complexity with practical people strategies that deliver measurable business outcomes.',
  },
  {
    n: '03',
    title: 'Aspiration & Execution',
    body: 'Our aspiration is to be among the world’s top three most innovative and effective HR consultancies. We don’t just create strategic frameworks, we partner with organizations to execute them, ensuring meaningful and measurable outcomes.',
  },
];

export const TEAM = [
  {
    name: 'Raj K',
    role: 'Founder & Managing Partner',
    tag: 'Founder',
    photo: 'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/51i7j6cl_Raj.jpg',
    bio: 'With over 25 years of global HR leadership experience, Raj helps organizations build high-performing cultures, strengthen leadership, and transform people practices through strategic HR advisory and executive search.',
    industries: ['Telecom', 'Technology', 'Internet', 'Retail', 'FMCG', 'Infrastructure', 'Consulting'],
    expertise: ['Executive Search', 'HR Strategy', 'Culture Transformation', 'Leadership Advisory', 'Change Management'],
    linkedin: 'https://www.linkedin.com/in/raj-k-b468231b1/',
  },
  {
    name: 'Shalini Srivastava',
    role: 'Partner — Leadership & Transformation',
    tag: 'Partner',
    photo: 'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/m80r68b4_Shalini.jpg',
    bio: 'Bringing 30+ years of experience, Shalini partners with organizations to develop transformative leaders, drive organizational change, and build high-performance cultures through strategic people practices.',
    industries: ['Retail', 'FMCG', 'Pharmaceuticals', 'Consulting'],
    expertise: ['Leadership Development', 'Executive Coaching', 'HR Transformation', 'Organizational Development', 'Change Management'],
    linkedin: 'https://www.linkedin.com/in/shalini-srivastava-1405b62/',
  },
  {
    name: 'Anjani Kumar',
    role: 'Partner — Global HR & Leadership Advisory',
    tag: 'Partner',
    photo: null,
    bio: 'With over 30 years of global HR experience, Anjani enables organizations to align leadership, culture, and people strategy, helping businesses build future-ready and high-performing teams.',
    industries: ['Manufacturing', 'Technology', 'Consulting', 'Global Enterprises'],
    expertise: ['Global HR Strategy', 'Executive Coaching', 'Organization Design', 'Talent Strategy', 'Culture Transformation'],
    linkedin: 'https://www.linkedin.com/in/anjanibkuumar/',
  },
  {
    name: 'Saikrishna',
    role: 'Strategy & Business Transformation Consultant',
    tag: 'Consultant',
    photo: 'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/bzo5rdrc_Srikar.jpg',
    bio: 'With 5+ years of consulting experience, Srikar helps organizations drive business transformation through strategy, AI-enabled solutions, digital innovation, and operational excellence.',
    industries: ['FMCG', 'Retail', 'Life Sciences', 'Healthcare', 'Pharmaceuticals', 'Technology Consulting'],
    expertise: ['Business Strategy', 'Digital Transformation', 'AI & Analytics', 'Product Strategy', 'Process Excellence'],
    linkedin: 'https://www.linkedin.com/in/saikrishna-buragadda-xlri/',
  },
  {
    name: 'Aditya Mohan',
    role: 'Partner — Talent Strategy',
    tag: 'Partner',
    photo: 'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/kjvdrgbf_Aditya.jpg',
    bio: 'With over 15 years of experience, Aditya helps organizations build future-ready workforces through strategic talent acquisition, workforce planning, leadership hiring, and HR business partnering.',
    industries: ['Technology', 'IT Services', 'GCC', 'Consulting'],
    expertise: ['Executive Search', 'Talent Acquisition', 'HRBP', 'Workforce Planning', 'Organization Development'],
    linkedin: 'https://www.linkedin.com/in/adchak/',
  },
  {
    name: 'Shoumik Rahate',
    role: 'Brand & Communications Strategist',
    tag: 'Strategist',
    photo: 'https://customer-assets-4nw71qhi.emergentagent.net/job_hr-excellence-global/artifacts/1hlwr944_Shoumik.webp',
    bio: 'An emerging communications professional passionate about crafting compelling brand narratives, thought leadership, and strategic content that strengthens employer branding and business visibility.',
    industries: ['Marketing', 'Branding', 'Media', 'Communications'],
    expertise: ['Content Strategy', 'Employer Branding', 'Corporate Communications', 'Creative Storytelling'],
    linkedin: 'https://www.linkedin.com/in/shoumik-rahate-23b777256/',
  },
];

export const SERVICES = [
  {
    id: 'talent-advisory',
    n: '01',
    title: 'Talent Advisory',
    caption: 'Executive search, workforce architecture, and long-term people strategy.',
    items: [
      'Executive Search',
      'Leadership Hiring',
      'Global Talent Acquisition',
      'Employer Branding',
      'People Strategy',
      'Workforce Planning',
      'HR Transformation',
      'Organization Design',
      'Succession Planning',
    ],
  },
  {
    id: 'culture-leadership',
    n: '02',
    title: 'Culture & Leadership',
    caption: 'Vision, values, engagement and transformation that outlasts any single leader.',
    items: [
      'Vision, Mission & Values',
      'Employee Engagement',
      'Change Management',
      'Leadership Development',
      'Culture Transformation',
    ],
  },
];

export const SERVICES_CLOSING =
  'Whether you’re scaling a startup, transforming a legacy business, or strengthening leadership capability, we help build organizations designed for long-term success.';

export const INDUSTRIES = [
  { name: 'Technology', icon: 'CircuitBoard' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Retail', icon: 'ShoppingBag' },
  { name: 'Consumer Goods', icon: 'Package' },
  { name: 'Financial Services', icon: 'Landmark' },
  { name: 'Professional Services', icon: 'Briefcase' },
  { name: 'Startups', icon: 'Rocket' },
  { name: 'Family Businesses', icon: 'Home' },
  { name: 'Global Capability Centres (GCC)', icon: 'Globe2' },
  { name: 'Others', icon: 'MoreHorizontal' },
];

export const INDUSTRIES_CLOSING = {
  a: 'Your business can only grow as fast as your talent can.',
  b: 'If that’s a challenge, let’s get in touch.',
};

export const TESTIMONIAL = {
  quote:
    'My brother and I have been associated with Raj Sir for the past 7 years now. Today, as our food startup has grown by leaps and bounds, we would really like to thank him for his innovative and effective guidance related to all aspects of our HR and culture, whether it’s creating a VMV (Vision, Mission, Values) statement, creating a highly effective talent acquisition and management playbook, or providing advice related to any critical areas of people management.',
  author: 'Siddharth Rustagi',
  role: 'Co-founder',
  company: 'Innobev',
};

export const MARQUEE_WORDS = [
  'People',
  'Culture',
  'Leadership',
  'Strategy',
  'Talent',
  'Transformation',
  'Growth',
  'Trust',
];

export const CONTACT = {
  email: 'contact@georgeandmilton.in',
  phone: '+91 98100 24550',
  linkedin: 'https://www.linkedin.com/company/george-and-milton',
  linkedinLabel: 'linkedin.com/company/george-and-milton',
};
